export default {"src":"/_next/static/media/close-icon.cea43909.svg","height":14,"width":14};